import { IFundHistoryState } from './types';

const state: IFundHistoryState = {
  items: [],
  selectedResultIndex: -1,
  cacheSuffix: '',
  businessCode: '',
  mustHaveCacheSuffix: true,
};

export default state;
